import React from 'react';

export default class Account extends React.Component{
	render()
	{
		return(
		<div>
            <h1>HOME PAGE</h1>
            </div>
			
			
		)
	} 
}
